import enums from "./enums.json";

/** Enum values exactly as the backend defines them (generated: `ui_docs_check.py --export-enums`). */
export const ENUMS = enums as Record<keyof typeof enums, string[]>;

export type EnumGroup = keyof typeof enums;

export type Tone = "ok" | "warn" | "danger" | "info" | "neutral";
export type ChipSpec = { label: string; tone: Tone };
